import { useState } from "react";
import {  doc, updateDoc,arrayUnion} from "firebase/firestore";
import { getAuth ,onAuthStateChanged} from "firebase/auth";
import { db } from "../Firebase";
import {ref,uploadBytes ,getDownloadURL } from 'firebase/storage';
import { storage } from "../Firebase";
import { Header } from "../Components/Header";

export const BottomsRegister = () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const [image,setImage] = useState(null);
    const [createObjectURL,setCreateObjectURL] = useState(null);
    const uploadToClient = (e) => {
        const file = e.target.files[0];
        setImage(file);
        setCreateObjectURL(URL.createObjectURL(file))
      }
      const uploadToServer = async ()=>{
        onAuthStateChanged(auth, async(user)=>{
            if(user){
                const result = await posstImage(image)
            }else{
                alert("ログインしてください");
            }
        })
      }
      const posstImage = async(image=null) =>{
        let uploadResult = "";
        const storageRef = ref(storage);
        const ext = image.name.split('.').pop();
        const hashName = Math.random().toString(36).slice(-8);
        const fullPath = '/Bottoms/' + hashName + ext ;
        const uploadRef = ref(storageRef, fullPath);
    
        await uploadBytes(uploadRef, image).then(async function(result) {
          console.log(result);
          console.log('Uploaded a blob or file!');
          await getDownloadURL(uploadRef).then(function(url){
              uploadResult = url;
          });
          const Pushdoc = doc(db,"users",user.uid);
          await updateDoc(Pushdoc,{
            bottoms_img_file:arrayUnion(uploadResult)
          }).then(()=>{
            alert("登録成功です")
          }).catch((err)=>{
            console.log('error',err)
            alert("登録失敗でしゅ")
          })
      });
      return uploadResult
      }
    return(
        <div className="homepage">
            <Header/>
            <div className="body">
                <div className="register">
                    <div className="register-title"><p> Bottoms </p></div>
                    <div className="register-image">
                        <p id="bg"><img  src={createObjectURL} width="300" height="250"/></p>
                    </div>
                    <div className="register-button">
                    <label className="buttonDownload">Upload<input type="file" id="selfile" onChange={uploadToClient}></input></label>
                    </div>
                    <div className="container">
                        <ul>
                            <li>
                                <input type="radio" id="f-option" name="selector"/>
                                <label htmlFor="f-option">summer</label>
                                <div className="check"></div>
                            </li>
                        
                            <li>
                                <input type="radio" id="t-option" name="selector"/>
                                <label htmlFor="t-option">winter</label>                               
                                <div className="check"><div className="inside"></div></div>
                            </li>
                        </ul>
                    </div>
                    <div className="send-button">
                        <button className="send-button-real" onClick={uploadToServer}>
                            <div className="svg-wrapper-1">
                                <div className="svg-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path fill="currentColor" d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"></path>
                                </svg>
                                </div>
                            </div>
                            <span>Send</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}